import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { setNavigator } from '@/lib/navigation'

/**
 * Registers the router's navigate with lib/navigation so non-React modules
 * (the React Query cache handlers, mainly) can redirect without a full page
 * reload. Renders nothing; must live inside <BrowserRouter>.
 */
export default function NavigationBridge() {
  const navigate = useNavigate()

  useEffect(() => {
    setNavigator(navigate)
    return () => setNavigator(null)
  }, [navigate])

  return null
}
